import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/password`;

class PasswordServices {
  async resetUserPassword({ userId, newPassword, description }) {
    try {
      const action = API_ROUTE + "/reset";
      const payload = {
        user_id: userId,
        new_password: newPassword,
        description,
      };
      return await requestToken.post(action, payload);
    } catch (error) {
      console.error("Error in resetUserPassword:", error);
      throw error;
    }
  }
}

export default PasswordServices;

